// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WebinarInvitation__title-ba35b6 {
  text-align: center;
  font: var(--font-title-6);
  color: var(--base-110);
  margin-top: 24px;
}

.WebinarInvitation__subtitle-d9ed1b {
  text-align: center;
  font: var(--font-body-4);
  color: var(--base-80);
  letter-spacing: var(--font-spacing-body-4);
}

.WebinarInvitation__description-fefe31 {
  text-align: center;
  font: var(--font-subtitle-4);
  color: var(--base-70);
  letter-spacing: var(-font-spacing-subtitle-4);
}

.WebinarInvitation__listen-only-c4f081 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font: var(--font-subtitle-3);
}

.WebinarInvitation__mic-icon-cdfdd0 {
  fill: var(--base-70);
}

.WebinarInvitation__start-call-d18d77 {
  padding: 24px 0;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/CallPreview/WebinarInvitation/WebinarInvitation.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,0CAAA;AACF;;AAEA;EACE,kBAAA;EACA,4BAAA;EACA,qBAAA;EACA,6CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,4BAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;AACF","sourcesContent":[".title {\n  text-align: center;\n  font: var(--font-title-6);\n  color: var(--base-110);\n  margin-top: 24px;\n}\n\n.subtitle {\n  text-align: center;\n  font: var(--font-body-4);\n  color: var(--base-80);\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.description {\n  text-align: center;\n  font: var(--font-subtitle-4);\n  color: var(--base-70);\n  letter-spacing: var(-font-spacing-subtitle-4);\n}\n\n.listen-only {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  font: var(--font-subtitle-3);\n}\n\n.mic-icon {\n  fill: var(--base-70);\n}\n\n.start-call {\n  padding: 24px 0;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `WebinarInvitation__title-ba35b6`,
	"subtitle": `WebinarInvitation__subtitle-d9ed1b`,
	"description": `WebinarInvitation__description-fefe31`,
	"listen-only": `WebinarInvitation__listen-only-c4f081`,
	"listenOnly": `WebinarInvitation__listen-only-c4f081`,
	"mic-icon": `WebinarInvitation__mic-icon-cdfdd0`,
	"micIcon": `WebinarInvitation__mic-icon-cdfdd0`,
	"start-call": `WebinarInvitation__start-call-d18d77`,
	"startCall": `WebinarInvitation__start-call-d18d77`
};
module.exports = ___CSS_LOADER_EXPORT___;
